import React from 'react';
import PropTypes from 'prop-types';
import { Link, Text } from 'components';
import classNames from 'classnames/bind';

import styles from './styles.pcss';
const cx = classNames.bind(styles);

export const ServiceAdditional = ({ onClick, children, isMobile }) => (
  <div className={cx('component', { isMobile })}>
    {onClick ? (
      <Link onClick={onClick}>{children}</Link>
    ) : (
      <Text color="grey60" size="size6-r">{children}</Text>
    )}
  </div>
);

ServiceAdditional.propTypes = {
  children: PropTypes.string,
  onClick: PropTypes.func,
  isMobile: PropTypes.bool,
};
